import { useLayoutEffect, useState } from 'react';

/**
 * Intercom's message banner pushes the page down by adding a `margin-top` to
 * `document.body`. This hook reads the current body `margin-top`
 * and keeps it in sync, so callers can offset their layout by it.
 */
export function useIntercomBodyMargin(): string {
  const [bodyMargin, setBodyMargin] = useState('0px');

  useLayoutEffect(() => {
    if (typeof document === 'undefined') return;

    const updateMargin = () => {
      setBodyMargin(getComputedStyle(document.body).marginTop || '0px');
    };

    updateMargin();

    const observer = new MutationObserver(updateMargin);
    observer.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });

    return () => {
      observer.disconnect();
    };
  }, []);

  return bodyMargin;
}
